<template>
    <el-dialog :visible.sync="visible" title="详情" :close-on-click-modal="false" :close-on-press-escape="false"
               :append-to-body="appendToBody" :destroy-on-close="true">
        <template>
            <el-descriptions title="活动信息" direction="vertical" :column="4" border>
                <el-descriptions-item label="活动名称">{{ detailData.activityName }}</el-descriptions-item>
                <el-descriptions-item label="参会人员">{{ detailData.member }}</el-descriptions-item>
                <el-descriptions-item label="活动时间">{{ detailData.startTime }}</el-descriptions-item>
                <el-descriptions-item label="活动地点">{{ detailData.address }}</el-descriptions-item>
                <el-descriptions-item label="组织机构或个人">{{ detailData.organizer }}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions title="现场照片/视频" direction="vertical" :column="4" border style="margin-top: 10px">
                <el-descriptions-item label="现场照片:">
                    <el-image v-for="(item,index) in detailData.imagesList" :key="index" style="width: 100px; height: 100px;margin-right: 10px" :src="`/api/file/get?name=${item}`" fit="contain"
                              :preview-src-list="[`/api/file/get?name=${item}`]"></el-image>
                </el-descriptions-item>
            </el-descriptions>
            <el-descriptions title="" direction="vertical" :column="4" border>
                <el-descriptions-item label="现场视频:">
                    <video
                        v-for="(item,index) in detailData.videosList" :key="index" style="width: 200px; height: 200px;margin-right: 10px" :src="`/api/file/get?name=${item}`"
                        ref="myVideo"
                        controls
                        oncontextmenu="return false"
                        class="video-box"
                    ></video>
                </el-descriptions-item>
            </el-descriptions>
        </template>
        <template slot="footer">
            <el-button type="primary" @click="dataFormSubmitHandle()">确定</el-button>
        </template>
    </el-dialog>
</template>

<script>
    export default {
        props: {
            appendToBody: {
                type: Boolean,
                require: false,
                default: false
            },
        },
        data() {
            return {
                visible: false,
                dataForm: {
                    id: ""
                },
                detailData: {},
                detailUrl: "",
                fits: ['fill', 'contain', 'cover', 'none', 'scale-down'],
                url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'
            };
        },
        computed: {},
        methods: {
            init(id) {
                this.detailData={}
                this.dataForm = { id };
                this.visible = true;
                this.getInfo();
            },
            // 获取信息
            getInfo() {
                axios
                    .get(this.$baseURL + `/api/activity/info/${this.dataForm.id}`)
                    .then(({ data: res }) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg);
                        }
                        let {imagesList, videosList} = res.activity
                        this.detailData = res.activity;
                        this.detailData.imagesList = imagesList && imagesList.split(',') || []
                        this.detailData.videosList = videosList && videosList.split(',') || []
                    })
                    .catch(() => { });
            },
            dataFormSubmitHandle() {
                this.visible = false
                this.dataForm={}
                this.dataForm={}
            }
        },
    };
</script>
